import React from "react";
import { useNavigate } from "react-router-dom";
import { MapPinIcon } from '@heroicons/react/24/solid';

export const CallToAction = () => {
  const navigate = useNavigate();
  const handleClick = () => {
    navigate("/services");
  };
  return (
    <div
      className={`nc-SectionHero max-w-7xl my-auto px-10 mx-auto flex flex-col-reverse lg:flex-col relative`}
      data-nc-id="SectionHero"
    >
      <div className="flex flex-col lg:flex-row lg:items-center">
        <div className="flex-grow lg:w-1/2 flex flex-col items-center space-y-8 sm:space-y-10 pb-14 xl:pr-14 lg:mr-10 xl:mr-0">
          <h2 className="font-black text-5xl md:text-6xl xl:text-7xl !leading-[114%] text-center">
            Quick and Easy Car Wash
          </h2>
          <span className="text-lg md:text-xl lg:text-2xl text-neutral-500 dark:text-neutral-400 text-center">
            Buy a single wash below. Our professional service ensures your vehicle looks its best in no time.
                    Convenient, affordable, and no appointment needed - just select a location and time that works for you.
          </span>
          <button
            className="transform hover:scale-105 transition-transform shadow-lg hover:shadow-xl bg-gradient-to-r from-red-500 to-red-600 px-12 py-6 sm:px-14 sm:py-7 rounded-full text-lg sm:text-xl font-semibold text-white flex items-center space-x-2 hover:from-red-600 hover:to-red-700 focus:outline-none focus:ring-2 focus:ring-red-500 focus:ring-opacity-50 duration-500"
            onClick={handleClick}
          >
            <MapPinIcon className={"size-5"}/>
            <span>Find us</span>
          </button>
        </div>
      </div>
    </div>
  );
};
